<template>
  <div class='home container'>
    <h1>Home</h1>
    <!-- <div class="status-weather">
      <weather-historic-data :duration="24" />
    </div> -->
  </div>
</template>

<script>
// import PlayersStatus from '@/components/players/PlayersStatus.vue'
// import WeatherHistoricData from '@/plugins/msWeather/components/WeatherHistoricData.vue'
// import BuildingData from '@/plugins/building/components/BuildingDataChart.vue'
// import { mapState, mapGetters } from 'vuex'

export default {
  name: 'home',
  components: {
    // PlayersStatus,
    // WeatherHistoricData,
    // BuildingData
  },
  data: function () {
    return {
    }
  },
  computed: {
    // ...mapState([
    //   'selectedPlayerId'
    // ]),
    // ...mapGetters([
    //   // 'selectedListPlayhead',
    //   'token'
    // ])
  }
}
</script>

<style lang="scss" scoped>

</style>
